import 'ui-core/widgets/table-of-content/js/table-of-content';

(function () {
    UX.tocJs.truncate = function () {
        try {
            UX.tocJs.$loa.not("[data-truncate='none']").truncate({
                lines: 2,
                type: 'list',
                seeMoreLink: true,
                seeMoreText: 'see more',
                seeLessText: 'see less',
            });
        } catch (err) {
            console.error(err);
        }
    };
})();
